import { render, staticRenderFns } from "./LandingPageTtcGroups.vue?vue&type=template&id=38df74af&scoped=true&"
import script from "./LandingPageTtcGroups.vue?vue&type=script&lang=js&"
export * from "./LandingPageTtcGroups.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageTtcGroups.vue?vue&type=style&index=0&id=38df74af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df74af",
  null
  
)

export default component.exports